// 漫画章节数据
export const chapters = [
  { id: 338, no: "第338话", title: "济世归来", time: "今天 08:30", isNew: true, status: "已更新" },
  { id: 337, no: "第337话", title: "丹炉之秘", time: "昨天 12:05", isNew: false, status: "已更新" },
  { id: 336, no: "第336话", title: "针起沉疴", time: "前天 09:12", isNew: false, status: "已更新" },
  { id: 335, no: "第335话", title: "医道争锋", time: "三天前 18:40", isNew: false, status: "已更新" },
  { id: 334, no: "第334话", title: "回春圣手", time: "四天前 10:22", isNew: false, status: "已更新" },
  { id: 333, no: "第333话", title: "金针渡厄", time: "五天前 21:15", isNew: false, status: "已更新" },
  { id: 332, no: "第332话", title: "青云万药谷", time: "六天前 08:50", isNew: false, status: "已更新" },
  { id: 331, no: "第331话", title: "灵药现世", time: "七天前 16:08", isNew: false, status: "已更新" },
  { id: 330, no: "第330话", title: "医仙大会", time: "八天前 11:33", isNew: false, status: "已更新" },
  { id: 329, no: "第329话", title: "药王秘录", time: "九天前 19:20", isNew: false, status: "已更新" },
  { id: 328, no: "第328话", title: "暗流涌动", time: "十天前 09:05", isNew: false, status: "已更新" },
  { id: 327, no: "第327话", title: "针石可愈", time: "十一天前 22:48", isNew: false, status: "已更新" },
];

// 连载进度
export const progress = {
  totalChapters: 338,
  finished: 285,
  totalVolumes: 12,
  currentVolume: 12,
  dailyAvg: 1,
  readPercent: 84,
};

// 追更提醒示例
export const updateNotice = [
  { no: "第338话", title: "济世归来", tip: "今早已更新，点击即可开始阅读" },
  { no: "第337话", title: "丹炉之秘", tip: "昨日更新，错过的话快去补" },
];

// 剧情主线 / 篇章
export const storyArc = [
  { key: "01", title: "凡医入世", desc: "身怀异术的年轻医者初入江湖，以银针破万难，在乱世中行医济世，逐渐揭开自身身世之谜。" },
  { key: "02", title: "药谷试炼", desc: "为寻救命灵药闯入青云万药谷，在重重机关与灵兽环伺中磨砺医道，结识同路知己。" },
  { key: "03", title: "医仙大会", desc: "四方医道高手齐聚争锋，一场看似较量医术的盛会，背后却暗藏权力与阴谋的较量。" },
  { key: "04", title: "济世归来", desc: "揭开身世真相后重返江湖，以仁心妙手救苍生于水火，踏上真正的医仙之路。" },
];

// 主要角色
export const characters = [
  {
    name: "沈星澜",
    alias: "天才医仙",
    desc: "胸怀济世之志的年轻医者，天赋异禀，医术卓绝，历经磨砺逐渐成长，心中始终秉持「医者仁心」。",
  },
  {
    name: "柳如烟",
    alias: "药谷圣女",
    desc: "青云万药谷传人，精通药理，性情清冷，与沈星澜因寻药结缘，并肩走过重重险境。",
  },
  {
    name: "顾长风",
    alias: "铁血剑客",
    desc: "重情重义的江湖剑客，为护故友踏入医道之争，一身剑意与沈星澜的银针相得益彰。",
  },
  {
    name: "薛无涯",
    alias: "医门长老",
    desc: "德高望重的医门长老，看尽医道浮沉，以一言点拨沈星澜，成为其成长路上的引路人。",
  },
];

// 常见问题
export const faqs = [
  {
    q: "天才医仙漫画今天更新了吗？",
    a: "是的，《天才医仙》于每周二、周四、周六固定更新，最新章节会在更新后第一时间在本站同步标注。当前最新话为第338话《济世归来》，今早已更新，点击最新章节即可开始阅读。",
  },
  {
    q: "如何第一时间知道最新章节更新？",
    a: "点击页面中的「收藏追更」按钮即可加入追更列表。收藏后每次更新都会第一时间在追更列表置顶提醒，无需再到处刷新查找最新进度。",
  },
  {
    q: "天才医仙漫画的连载进度现在到哪里了？",
    a: "目前《天才医仙》已连载至第338话，正处第12卷「济世归来」篇章。本站连载进度板块会持续同步最新卷数与总话数，今天有没有更新一眼便知。",
  },
  {
    q: "最新章节可以免费阅读吗？",
    a: "《天才医仙》最新章节支持免费追更，阅读进度会自动记录。收藏本作后，最新章节与新话上线都会第一时间提醒，方便您持续免费追更。",
  },
  {
    q: "如何调整阅读进度或清除追更记录？",
    a: "您可以在连载进度板块查看已读话数，点击「重置阅读记录」即可清空本地追更进度，重新开始阅读。",
  },
  {
    q: "故事主要讲述了什么内容？",
    a: "故事讲述天赋异禀的年轻医者沈星澜，以银针妙手行走乱世、济世救人的成长历程，穿插药谷试炼、医仙大会等精彩篇章，兼具热血冒险与医道哲思。",
  },
];

// 网站口碑
export const testimonials = [
  { name: "追更老粉·阿航", text: "更新超及时，收藏后新话一到就提醒，再也没错过过最新一章。" },
  { name: "漫画同好·小满", text: "连载进度做得清清楚楚，哪一话看到哪了、还剩多少卷，一目了然。" },
  { name: "资深书虫·南星", text: "剧情和角色介绍很全，入坑之前先看一遍，阅读体验好了不少。" },
];